import styled, { css } from 'styled-components';
import { gridPattern } from '../../styles/gridStyles';

interface WrapperProps {
  hideButtonOnDesk?: boolean;
}

export const Wrapper = styled.div<WrapperProps>`
  ${gridPattern}
  width: 100%;
  max-width: 420px !important;
  margin: 0 auto;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 8px !important;
  justify-content: center;
  align-items: center;
  text-align: center;

  svg {
    margin-bottom: 16px;
  }

  div:last-of-type {
    margin-bottom: 16px;
  }

  button span {
    font-size: 16px;
  }

  ${({ hideButtonOnDesk }) =>
    hideButtonOnDesk &&
    css`
      @media (min-width: 1366px) {
        button {
          display: none;
          visibility: hidden;
        }
      }
    `}
`;
